<template>
    <v-list class="soli-duration"
        ><v-list-item v-for="duration in getDurations" :key="duration.value">
            <SoliBtn
                block
                outlined
                :text="duration.display"
                :disabled="setDisabled(duration)"
                :icon="setIcon(duration)"
                color="contrast--text"
                class="my-1"
                @click="$emit('input', duration.value)"
            />
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        eventDuration: {
            type: Number,
            default: null,
        },
        eventType: {
            type: Object,
            default: () => {},
        },
        purchaseOptions: {
            type: Array,
            default: () => [],
        },
        showAll: {
            type: Boolean,
            default: true,
        },
        totalLessonCredits: {
            type: Number,
            default: null,
        },
        filter: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            durations: [
                {
                    display: "30 Minutes",
                    value: 30,
                },

                {
                    display: "60 Minutes",
                    value: 60,
                },
                {
                    display: "45 Minutes",
                    value: 45,
                },
                {
                    display: "90 Minutes",
                    value: 90,
                },
                {
                    display: "15 Minutes",
                    value: 15,
                    //disabled: !this.can("Work"),
                },
            ],
        };
    },
    computed: {
        getDurations() {
            return this.durations.filter((e) => !this.filter.includes(e.value));
        },
    },
    methods: {
        setIcon(duration) {
            if (duration.value == this.eventDuration) return "assignment";
            return null;
        },
        setDisabled(duration) {
            if (duration.disabled) return true;
            if (this.eventType?.reschedule) {
                if (this.showAll) return false;
                if (this.totalLessonCredits < duration.value) return true;
            }
            if (this.purchaseOptions.length) {
                return !this.purchaseOptions?.some(
                    (e) => e.duration == duration.value
                );
            }
            return false;
        },
        /*getSelectedType == 'Assessment'
                    ? duration.value != 30
                    : getSelectedType == 'Reschedule'
                    ? showAllRescheduleStudents
                        ? false
                        : getStudent
                        ? getTotalLessonCredits <
                            duration.value
                        : false
                    : getPurchaseOption.length
                    ? !getPurchaseOption.some(
                            (e) =>
                                e.duration == duration.value
                        )
                    : false*/
    },
};
</script>

<style></style>
